import { createAsyncThunk } from '@reduxjs/toolkit';
import PortfolioAPI from './portfolioAPI'

// --- PORTFOLIOS ---
export const createPortfolioThunk = createAsyncThunk(
  'portfolio/create',
  async (portfolioData, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.create(portfolioData);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchPortfoliosThunk = createAsyncThunk(
  'portfolio/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.fetchAll();
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchPortfolioByIdThunk = createAsyncThunk(
  'portfolio/fetchOne',
  async (id, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.fetchById(id);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updatePortfolioThunk = createAsyncThunk(
  'portfolio/update',
  async ({ id, portfolioData }, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.update(id, portfolioData);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const deletePortfolioThunk = createAsyncThunk(
  'portfolio/delete',
  async (id, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.delete(id);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// --- STOCKS ---
export const bulkCreateStocksThunk = createAsyncThunk(
  'stocks/bulkCreate',
  async ({ portfolioId, stocks }, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.bulkCreateStocks(portfolioId, stocks);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchStocksByPortfolioIdThunk = createAsyncThunk(
  'stocks/fetchByPortfolio',
  async (portfolioId, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.fetchStocks(portfolioId);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateStockThunk = createAsyncThunk(
  'stocks/update',
  async ({ portfolioId, stockId, stockData }, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.updateStock(portfolioId, stockId, stockData);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const deleteStockThunk = createAsyncThunk(
  'stocks/delete',
  async ({ portfolioId, stockId }, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.deleteStock(portfolioId, stockId);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// --- ANALYTICS ---
export const createAnalyticsThunk = createAsyncThunk(
  'analytics/create',
  async ({ portfolioId, analyticsData }, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.createAnalytics(portfolioId, analyticsData);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const fetchAnalyticsByPortfolioIdThunk = createAsyncThunk(
  'analytics/fetchByPortfolio',
  async (portfolioId, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.fetchAnalytics(portfolioId);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateAnalyticsThunk = createAsyncThunk(
  'analytics/update',
  async ({ portfolioId, analyticsData }, { rejectWithValue }) => {
    try {
      return await PortfolioAPI.updateAnalytics(portfolioId, analyticsData);
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
